export default {
  isDark: true,
  backgroundComponent: '#031020',
  textColor: '#7e8eaa',
  textColorAccent: '#ffffff',
  buttonLinkColor: '#ffffff',
  modalBackground: '#051932',
  componentTextColor: '#ffffff',
  tagBackground: '#051932',
};
